var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { addDnDHandlers } from "./ListViewDragHelper";
var TagView = /** @class */ (function (_super) {
    __extends(TagView, _super);
    function TagView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagView.prototype.render = function () {
        var _this = this;
        return React.createElement("span", { style: { cursor: 'pointer' }, id: this.props.id, onClick: function (e) {
                e.stopPropagation();
                _this.props.onSelected(e.currentTarget);
            }, ref: function (e) {
                if (e) {
                    addDnDHandlers(e);
                    e.addEventListener('add_to_crate', function () {
                        _this.props.onAddCrate(e);
                    });
                }
            }, draggable: this.props.enableDrag, className: 'tag-link' },
            React.createElement("span", { className: 'tag-view ' + (this.props.selected ? 'selected' : '') }, this.props.text));
    };
    return TagView;
}(React.PureComponent));
export default TagView;
//# sourceMappingURL=TagView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/TagView.js
// module id = 435
// module chunks = 0